"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HtgSys = void 0;
var _react = _interopRequireWildcard(require("react"));
var _drei = require("@react-three/drei");
var _reactRedux = require("react-redux");
var _List = require("./List");
var _useGetComponentsByParams = require("../../../hooks/store/useGetComponentsByParams");
var _constants = require("../../../utils/constants");
var _selectors = require("../../../redux/selectors");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const HtgSys = exports.HtgSys = /*#__PURE__*/(0, _react.memo)(() => {
  const api = (0, _drei.useBounds)();
  const type = _constants.TypesByDep.HtgSys;
  const idList = (0, _useGetComponentsByParams.useGetComponentsByDepAndByType)({
    type
  });
  const modelPosition = (0, _reactRedux.useSelector)((0, _selectors.selectStructurePositionsByType)(type));
  (0, _react.useEffect)(() => {
    api.refresh().fit();
  }, [api, idList.length]);
  return /*#__PURE__*/_react.default.createElement("group", {
    dispose: null,
    position: modelPosition
  }, /*#__PURE__*/_react.default.createElement(_List.List, {
    idList: idList
  }));
});